export default __webpack_public_path__ + "static/media/chatencrypt.b14a6343.svg";